var $ = require('jquery');
var headerLoad = require('./modules/headerLoad');
var owl = require('./modules/call-owl');
var matchheight = require('./modules/match-height');
var options = require('./modules/optionsHover');
var slideIn = require('./modules/bannerSlide');
var pageNav = require('./modules/pageNavigation');
var youtubeVideo = require('./modules/youtubeVideo');
var placeholder = require('./modules/placeholder');
var enquiryForm = require('./modules/enquiryForm');
var roundChart = require('./modules/roundChart');
var countryFranchise = require('./modules/googleFind');
var truncate = require('./modules/limitxt');
var select2 = require('./modules/call-select2');
var countryMedia = require('./modules/country-media');
var objectFit = require('./modules/init-object-fit-polyfill');
var initSVG = require('./rebuild-components/init-svg4everybody');
var initIE = require('./rebuild-components/init-ie11');

// Initialises on load.
require('./modules/franchise-navigation');
var accordion = require('./modules/accordion');

var self = {};

self.initialise = function() {
  var $content = $('.loader');
  if ($content.length) {
    headerLoad.initialise($content);
  }

  var $owlCall = $('.owl-carousel, .owl-carousel2, #testimonial-carousel');
  if ($owlCall.length) {
    owl.initialise();
  }

  var select2Call = $('select');
  if (select2Call.length) {
    select2.initialise();
  }

  var $match = $('body');
  if ($match.length) {
    matchheight.initialise();
  }

  var $optionsHover = $('.option-box');
  if ($optionsHover.length) {
    options.initialise($optionsHover);
  }

  var $fadeIn = $('.overlay-text');
  if ($fadeIn.length) {
    slideIn.initialise($fadeIn);
  }

  var $pageNav = $('.page-navigation');
  if ($pageNav.length) {
    pageNav.initialise($pageNav);
  }

  var $placeholders = $('label.sr-only');
  if ($placeholders.length) {
    placeholder.initialise($placeholders);
  }

  var $youtubePlayer = $('.youtube-player');
  if ($youtubePlayer.length) {
    youtubeVideo.initialise($youtubePlayer);
  }

  var $enquiry = $('.enquiry-form, .contact');
  if ($enquiry.length) {
    enquiryForm.initialise();
  }

  var $chart = $('.chart');
  if ($chart.length) {
    roundChart.initialise($chart);
  }

  var $franchises = $('.find-franchises');
  if ($franchises.length) {
    countryFranchise.init($franchises);
  }

  var $limittxt = $('body');
  if ($limittxt.length) {
    truncate.initialise($limittxt);
  }

  var $countryMedia = $('.inxpress-country .media__img');
  if ($countryMedia.length) {
    countryMedia.initialise();
  }

  var $accordionTitle = $('.accordion-title');
  if ($accordionTitle.length) {
    accordion.initialise();
  }

  objectFit.initialise();

  initSVG.initialise();

  initIE.initialise();
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/app.js